export class Unsubscriber {
  id: number;
  contactLists: ContactList[];
}

export class ContactList {
  id: number;
  name: string;

  constructor(id?: number, name?: string) {
    this.id = id;
    this.name = name;
  }    
}
